import { Button } from "antd";
import { useTranslation } from "react-i18next";

const Content = ({ onClick, user }) => {
  const { t } = useTranslation();

  const renderContent = () => {
    return user?.level === 0
      ? t("onb.activation-content")
      : t("onb.active-fund-detail");
  };

  const renderBtnContent = () => {
    return user?.level === 0 ? t("activation") : t("accept");
  };

  return (
    <div className="flex flex-col">
      <span className="mx-5">{renderContent()}</span>
      <div className=" border-t border-gray--7 px-5 mt-5">
        <Button
          block
          className="primary-button-large mt-4 justify-center "
          onClick={onClick}
        >
          {renderBtnContent()}
        </Button>
      </div>
    </div>
  );
};
export default Content;
